import axios from "axios";
import timePattern from "../../models/gestionTiempos/timePattern/timePattern";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  new = (data) => {
    let token = localStorage.getItem("token");
    let empId = parseInt(localStorage.getItem("empId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    payload = {
      empId: empId,
      fecDesde: data.from + "T00:00:00.000Z",
      fecHasta:
        data.to == null
          ? undefined
          : moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      liqHoras: data.liqHoras,
      tarde: data.tarde,
      retAnt: data.retAnt,
      licPar: data.licPar,
      licTot: data.licTot,
      caidas: data.caidas,
      hCaiTol: data.tolerance,
      hCaiCsCostoId: data.cost,
      autorizLiq: data.autoriz,
      fecha: data.date + "T00:00:00.000Z",
    };

    return axios.post(`${url}/emppautas`, payload, { headers });
  };
  getTimePattern = () => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = localStorage.getItem("empId");
    return axios
      .get(`${url}/emppautas/${empId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return timePattern.fromJson(item);
        })
      );
  };
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const empId = localStorage.getItem("empId");
    const fecdesde = data.from;

    return axios.delete(`${url}/emppautas/${empId}&${fecdesde}`, {
      headers,
    });
  };
  edit = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const empId = localStorage.getItem("empId");
    const fecdesde = data.fromOld;
    let payload;
    payload = {
      fecDesde: data.from + "T00:00:00.000Z",
      liqHoras: data.liqHoras,
      tarde: data.tarde,
      retAnt: data.retAnt,
      licPar: data.licPar,
      licTot: data.licTot,
      caidas: data.caidas,
      hCaiTol: data.tolerance,
      hCaiCsCostoId: data.cost,
      autorizLiq: data.autoriz,
      fecha: data.fromOld + "T00:00:00.000Z",
    };
    if (data.haNoEx) {
      payload = {
        ...payload,
        haNoEx: data.haNoEx,
      };
    } else if (data.to && !data.haNoEx) {
      payload = {
        ...payload,
        fecHasta: moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      };
    }

    return axios.patch(`${url}/emppautas/${empId}&${fecdesde}`, payload, {
      headers,
    });
  };
}
export default service;
